<asw-common-error-pres
  [errorInfo]="errorInfo"
  [displayErrorKey]="displayErrorKey$ | async"
  [fixedErrorMsgKey]="fixedErrorMsgKey"
  [buttonLabelMsgKey]="buttonLabelMsgKey"
  [showCloseBtn]="showCloseBtn"
  (confirm$)="confirmNavigate()"
  (close$)="popupClose()"
></asw-common-error-pres>
